import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'daysToDuration'
})
export class DaysToDurationPipe implements PipeTransform {

  transform(days: number): string {
    if (days == null || days < 0) {
      return '';
    }
    const year = 365;
    const month = 30;

    const years = Math.floor(days / year);
    days %= year;
    const months = Math.floor(days / month);
    days %= month;

    let result = '';
    if (years > 0) {
      result += `${years} Year${years > 1 ? 's' : ''} `;
    }
    if (months > 0) {
      result += `${months} Month${months > 1 ? 's' : ''} `;
    }
    if (days > 0 || result === '') {
      result += `${days} Day${days !== 1 ? 's' : ''}`;
    }
    return result.trim();
  }

}
